(function () {
  const forms = document.querySelectorAll('.pt-inline-search');
  if (!forms.length) return;

  forms.forEach(setup);

  function setup(form) {
    const input = form.querySelector('input[type="search"]');
    const panel = form.parentElement && form.parentElement.querySelector('.pt-search-suggest');
    if (!input || !panel) return;

    const currency = form.dataset.currency || '$';
    const catalogUrl = form.dataset.catalog;
    let products = [];
    let catalogReady = false;
    let activeIndex = -1;
    let matches = [];

    const catalog = loadCatalog(catalogUrl).then(function (list) {
      products = list;
      catalogReady = true;
      if (input.value.trim()) render(input.value);
    });

    input.addEventListener('input', function () {
      activeIndex = -1;
      render(input.value);
    });

    input.addEventListener('keydown', function (event) {
      const items = panel.querySelectorAll('.pt-search-suggest__item');
      if (event.key === 'ArrowDown') {
        if (!items.length) return;
        event.preventDefault();
        activeIndex = activeIndex < items.length - 1 ? activeIndex + 1 : 0;
        markActive(items);
      } else if (event.key === 'ArrowUp') {
        if (!items.length) return;
        event.preventDefault();
        activeIndex = activeIndex > 0 ? activeIndex - 1 : items.length - 1;
        markActive(items);
      } else if (event.key === 'Escape') {
        close();
      } else if (event.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
        event.preventDefault();
        items[activeIndex].click();
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.parentElement.contains(event.target)) close();
    });

    function render(raw) {
      const query = raw.trim();
      if (!query) {
        close();
        return;
      }

      if (!catalogReady) {
        open();
        panel.replaceChildren(status('Searching…'));
        catalog.then(function () {
          if (input.value.trim() === query) render(query);
        });
        return;
      }

      const words = query.toLowerCase().split(/\s+/).filter(Boolean);
      matches = products
        .map(function (product) {
          return { product: product, score: scoreProduct(product, query, words) };
        })
        .filter(function (row) {
          return row.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score || a.product.title.localeCompare(b.product.title);
        });

      const shown = matches.slice(0, 8);
      panel.replaceChildren();

      if (!shown.length) {
        panel.append(status('No matches for “' + query + '”'));
      } else {
        shown.forEach(function (row, index) {
          panel.append(resultLink(row.product, words, index));
        });
        if (matches.length > shown.length) {
          const all = document.createElement('a');
          all.className = 'pt-search-suggest__all';
          all.href = form.action + '?type=product&q=' + encodeURIComponent(query);
          all.textContent = 'See all ' + matches.length + ' matches';
          panel.append(all);
        }
      }

      open();
      input.setAttribute('aria-activedescendant', '');
    }

    function resultLink(product, words, index) {
      const link = document.createElement('a');
      link.className = 'pt-search-suggest__item';
      link.id = 'pt-search-option-' + index;
      link.href = product.url;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');

      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.width = 48;
        img.height = 48;
        link.append(img);
      }

      const copy = document.createElement('span');
      copy.className = 'pt-search-suggest__copy';
      const title = document.createElement('strong');
      title.append(highlight(product.title, words));
      const price = document.createElement('span');
      price.textContent = product.price ? currency + Number(product.price).toFixed(2) : '';
      copy.append(title, price);
      link.append(copy);
      return link;
    }

    function markActive(items) {
      items.forEach(function (item, index) {
        const selected = index === activeIndex;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected) {
          input.setAttribute('aria-activedescendant', item.id);
          item.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.hidden = true;
      panel.replaceChildren();
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-activedescendant', '');
    }
  }

  function status(text) {
    const node = document.createElement('p');
    node.className = 'pt-search-suggest__status';
    node.textContent = text;
    return node;
  }

  function scoreProduct(product, query, words) {
    const title = product.title.toLowerCase();
    const haystack = (product.title + ' ' + product.type + ' ' + product.tags).toLowerCase();
    if (!words.every(function (word) { return haystack.indexOf(word) !== -1; })) return 0;

    let score = 1;
    if (title.indexOf(query.toLowerCase()) === 0) score += 80;
    else if (title.indexOf(query.toLowerCase()) !== -1) score += 30;

    words.forEach(function (word) {
      title.split(/\s+/).forEach(function (part) {
        if (part.indexOf(word) === 0) score += 20;
      });
    });
    return score;
  }

  function highlight(title, words) {
    const escaped = words
      .map(function (word) { return word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); })
      .filter(Boolean);
    const frag = document.createDocumentFragment();
    if (!escaped.length) {
      frag.append(document.createTextNode(title));
      return frag;
    }
    const pattern = new RegExp('(' + escaped.join('|') + ')', 'ig');
    let last = 0;
    title.replace(pattern, function (match, _group, offset) {
      if (offset > last) frag.append(document.createTextNode(title.slice(last, offset)));
      const mark = document.createElement('mark');
      mark.textContent = match;
      frag.append(mark);
      last = offset + match.length;
      return match;
    });
    if (last < title.length) frag.append(document.createTextNode(title.slice(last)));
    return frag;
  }

  function loadCatalog(url) {
    const pages = [1, 2, 3, 4];
    return pages.reduce(function (chain, page) {
      return chain.then(function (list) {
        if (list.done) return list;
        return fetch(url + '?limit=250&page=' + page, { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : { products: [] }; })
          .then(function (data) {
            const seen = {};
            list.items.forEach(function (item) { seen[item.url] = true; });
            (data.products || []).forEach(function (product) {
              const item = mapProduct(product);
              if (!item.url || seen[item.url]) return;
              seen[item.url] = true;
              list.items.push(item);
            });
            if (!data.products || data.products.length < 250) list.done = true;
            return list;
          })
          .catch(function () {
            list.done = true;
            return list;
          });
      });
    }, Promise.resolve({ items: [], done: false })).then(function (list) {
      return list.items;
    });
  }

  function mapProduct(product) {
    const image = product.images && product.images[0] && product.images[0].src;
    const variant = product.variants && product.variants[0];
    return {
      title: product.title || '',
      type: product.product_type || '',
      tags: Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || ''),
      url: '/products/' + product.handle,
      price: variant ? variant.price : '',
      image: thumb(image)
    };
  }

  function thumb(src) {
    if (!src) return '';
    return src.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_96x96$1$2');
  }
})();
